<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import { ref } from 'vue'
import DateRangePicker, { type DateRange } from '../primevue/DateRangePicker.vue'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()

const pickerRef = ref<InstanceType<typeof DateRangePicker> | undefined>()

async function onUpdated(value?: DateRange) {
  await props.context.node.input(
    value
      ? {
          start: new Date(value.start!),
          end: value.end ? new Date(value.end) : undefined
        }
      : undefined
  )
  pickerRef.value?.$el.dispatchEvent(new Event('change', { bubbles: true }))
}
</script>

<template>
  <DateRangePicker v-bind="context.attrs" ref="pickerRef" :model-value="context.value" @update:modelValue="onUpdated" />
</template>
